import React, { useMemo, memo } from "react";
import { useTranslation } from "react-i18next";
import media from "cssMix/index";

// lottie
import searchListEmptyAnimation from "lottie/searchListEmpty";
import tagListEmptyAnimation from "lottie/tagListEmpty";
import styled from "styled-components";

export default memo(({ typeValue, filteredGameList, searchValue }) => {
  const { t } = useTranslation();

  const config = useMemo(() => {
    const configData = { text: "", animation: false };
    if (searchValue) {
      configData.text = t("cantFindGame");
      configData.animation = searchListEmptyAnimation;
    } else {
      configData.text = t("soEmpty");
      configData.animation = tagListEmptyAnimation;
    }
    return configData;
  }, [searchValue, t]);

  return (
    filteredGameList.size === 0 && (
      <>
        <StyledEmpty searchValue={searchValue} />
        <Text>{config.text}</Text>
      </>
    )
  );
});

const StyledEmpty = styled.div`
  width: 400px;
  height: 334px;
  margin: 0 auto 52px auto;
  box-sizing: border-box;
  background: ${(props) =>
    props.searchValue
      ? `url('images/empty_search.png') no-repeat;`
      : `url('images/empty.png') no-repeat;`};
  background-size: contain;
  ${media.tablet`
width:380px;
`}
  ${media.mobile`
    width:305px;
    height:260px;
    `}
`;

const Text = styled.div`
  font-size: 16px;
  color: #c1bfb9;
  text-align: center;
  margin-bottom: 38px;
  ${media.tablet`
    font-size:15px;
  `}
`;
